@for (alert of alerts; track alert) {
  <div class="alert">
    <app-alert [alert]="alert"></app-alert>
  </div>
}